import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import { FallbackView } from '../../_metronic/partials'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const CustomerPage = lazy(() => import('../modules/customers/CustomersPage'))
  const AnalyticsPage = lazy(() => import('../modules/analytics/AnalyticsPage'))
  const ServicePage = lazy(() => import('../modules/service/ServicePage'))
  const DevicesPage = lazy(() => import('../modules/device/DevicesPage'))
  const StatisticsPage = lazy(() => import('../modules/statistics/StatisticsPage'))

  const SimDataPage = lazy(() => import('../modules/simdata/SimDataPage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <ToastContainer
        position="bottom-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/sim-data' component={SimDataPage} />
        <Route path='/customers' component={CustomerPage} />
        <Route path='/analytic' component={AnalyticsPage} />
        <Route path='/service' component={ServicePage} />
        <Route path='/device' component={DevicesPage} />
        <Route path='/statistics' component={StatisticsPage} />

        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
